import apiClient from '@/services/axios'
import config from '@/configs'

// teams functions
// get all teams
export async function fetchTeams() {
  return apiClient
    .get(config.api.pm.teams)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[PM/Teams API]:', err))
}
